import { connect } from 'react-redux'

import ChannelResult from '../components/channel-result'

const mapStateToProps = (state) => ({
    channelAPIURL: state.initial.endpoints.channelAPIURL,
})

export default connect(mapStateToProps)(ChannelResult)
